
export default {
  data() {
    return {
      cloudserver: [
        {
          name: "ساخت خودکار سرور با OS نصب شده",
          status: true,
        },
        // {
        //   name: "امکان خرید سرور خارجی",
        //   status: true,
        // },
        {
          name: "پنل تحت وب",
          status: true,
        },
        {
          name: "کنسول وب دسترسی به سرور",
          status: true,
        },
        {
          name: "پشتیبانی رایگان ۲۴/۷",
          status: true,
        },
        {
          name: "مدیریت فایروال",
          status: true,
        },
        {
          name: "ارتقا یا کاهش سریع منابع",
          status: true,
        },
        {
          name: "انتخاب سطح کیفی سرویس",
          status: true,
        },
        {
          name: "یک ماشین مجازی",
          status: true,
        },
        {
          name: "یک آی‌پی پابلیک",
          status: true,
        },
        {
          name: "بارگذاری ایمیج سیستم‌عامل دلخواه",
          status: false,
        },
        {
          name: "حداکثر منابع نامحدود",
          status: false,
        },
        {
          name: "طراحی معماری ابری اختصاصی",
          status: false,
        },

        {
          name: "مدیریت SDN ",
          status: false,
        },
        {
          name: "مدیریت دیسک مجازی ",
          status: false,
        },

        {
          name: "Load Balancer",
          status: false,
        },
        {
          name: "ارکستریشن",
          status: false,
        },
      ],
      datacenter: [
        {
          name: "ساخت خودکار سرور با OS نصب شده",
          status: false,
        },
        // {
        //   name: "امکان خرید سرور خارجی",
        //   status: true,
        // },
        {
          name: "پنل تحت وب پیشرفته",
          status: true,
        },
        {
          name: "کنسول وب دسترسی به سرور",
          status: true,
        },
        {
          name: "پشتیبانی رایگان ۲۴/۷",
          status: true,
        },
        {
          name: "مدیریت فایروال پیشرفته",
          status: true,
        },
        {
          name: "ارتقا یا کاهش سریع منابع",
          status: true,
        },
        {
          name: "انتخاب سطح کیفی سرویس",
          status: true,
        },
        {
          name: "تعداد نامحدود ماشین مجازی",
          status: true,
        },
        {
          name: "تعداد نامحدود آی‌پی پابلیک",
          status: true,
        },
        {
          name: "بارگذاری ایمیج سیستم‌عامل دلخواه",
          status: true,
        },
        {
          name: "حداکثر منابع نامحدود",
          status: true,
        },
        {
          name: "طراحی معماری ابری اختصاصی",
          status: true,
        },

        {
          name: "مدیریت SDN ",
          status: true,
        },
        {
          name: "مدیریت دیسک مجازی ",
          status: true,
        },

        {
          name: "Load Balancer",
          status: true,
        },
        {
          name: "ارکستریشن",
          status: true,
        },
      ],
      showMore: false,
    };
  },
  methods: {
    goToVps() {},
  },
};
